// extracted by mini-css-extract-plugin
export default {"splitter":"SplitPane_splitter__hylIq","pane":"SplitPane_pane__v9o3q","splitterBar":"SplitPane_splitterBar__JT+rl","hover":"SplitPane_hover__BwtOo"};